import request from '../../utils/request'
import prefix from '../prefix'
import { encryptionPassword } from '../../utils/encryption'
import auth from '../auth'

/***
 * 用户登录
 * @param data
 * @returns {AxiosPromise}
 */
export const login = data => {
  return request({
    url: prefix + '/user/login',
    method: 'post',
    data: {
      ...data,
      password: encryptionPassword(data.password)
    }
  })
}

/***
 * 登出
 * @param data
 * @returns {AxiosPromise}
 */
export const logout = data => {
  return request({
    url: prefix + '/user/logout',
    method: 'post',
    data
  })
}

/***
 * 用户绑定谷歌验证器
 * @param data
 * @returns {AxiosPromise}
 */
export const userBindGoogle = data => {
  return request({
    url: prefix + '/user/bind-google',
    method: 'post',
    data: {
      ...data,
      password: encryptionPassword(data.password)
    }
  })
}

/***
 * 获取用户是否绑定谷歌验证
 * @param data
 * @returns {AxiosPromise}
 */
export const userHasBoundGoogle = data => {
  return request({
    url: prefix + '/user/has-bound-google',
    method: 'post',
    data
  })
}

/***
 * 获取用户是否绑定谷歌验证
 * @param data
 * @returns {AxiosPromise}
 */
export const userBindGoogleGet = data => {
  return request({
    url: prefix + auth + '/user/bind-google-get',
    method: 'post',
    data
  })
}

/***
 * 获取用户信息
 * @param data
 * @returns {AxiosPromise}
 */
export const userGetLoginInfo = data => {
  return request({
    url: prefix + '/user/get-login-info',
    method: 'post',
    data
  })
}

/***
 * 修改当前用户的资金密码
 * @param data
 * @returns {AxiosPromise}
 */
export const userEditFundPwd = data => {
  return request({
    url: prefix + auth + '/user/edit-fund-pwd',
    method: 'post',
    data: {
      ...data,
      newPwd: encryptionPassword(data.newPwd),
      oldPwd: encryptionPassword(data.oldPwd),
      prePwd: encryptionPassword(data.oldPwd)
    }
  })
}

/***
 * 修改当前用户的登录密码
 * @param data
 * @returns {AxiosPromise}
 */
export const userEditLoginPwd = data => {
  return request({
    url: prefix + auth + '/user/edit-login-pwd',
    method: 'post',
    data: {
      ...data,
      newPwd: encryptionPassword(data.newPwd),
      oldPwd: encryptionPassword(data.oldPwd),
      prePwd: encryptionPassword(data.oldPwd)
    }
  })
}

/***
 * 绑定当前用户的资金密码
 * @param data
 * @returns {AxiosPromise}
 */
export const userBindFundPwd = data => {
  return request({
    url: prefix + auth + '/user/bind-fund-pwd',
    method: 'post',
    data: {
      ...data,
      password: encryptionPassword(data.password),
      passwordPre: encryptionPassword(data.passwordPre)
    }
  })
}

/***
 * 获取用户自选币列表
 * @param data
 * @returns {AxiosPromise}
 */
export const userFavorVcList = data => {
  return request({
    url: prefix + auth + '/user/favor-vc/list',
    method: 'post',
    data
  })
}

/***
 * 添加用户自选币
 * @param data
 * @returns {AxiosPromise}
 */
export const userFavorVcAdd = data => {
  return request({
    url: prefix + auth + '/user/favor-vc/add',
    method: 'post',
    data
  })
}

/***
 * 删除用户自选币
 * @param data
 * @returns {AxiosPromise}
 */
export const userFavorVcDelete = data => {
  return request({
    url: prefix + auth + '/user/favor-vc/delete',
    method: 'post',
    data
  })
}

/***
 * 获取新增用户的返点范围
 * @param data
 * @returns {AxiosPromise}
 */
export const userPortalUserAddPointPercentList = data => {
  return request({
    url: prefix + auth + '/user/portal-user-add-point-percent-list',
    method: 'post',
    data
  })
}

/***
 * 新增用户
 * @param data
 * @returns {AxiosPromise}
 */
export const userAdd = data => {
  return request({
    url: prefix + auth + '/user/add',
    method: 'post',
    data
  })
}

/***
 * 我的团队列表
 * @param data
 * @returns {AxiosPromise}
 */
export const userTeamPage = data => {
  return request({
    url: prefix + auth + '/user/team-page',
    method: 'post',
    data
  })
}

/***
 * 新用户注册
 * @param data
 * @returns {AxiosPromise}
 */
export const userRegister = data => {
  return request({
    url: prefix + '/user/register',
    method: 'post',
    withNoToken: true,
    data: {
      ...data,
      loginPwd: encryptionPassword(data.loginPwd),
      preLoginPwd: encryptionPassword(data.preLoginPwd)
    }
  })
}

/***
 * 重新加载当前登录用户邀请码
 * @param data
 * @returns {AxiosPromise}
 */
export const userReloadInviteCode = data => {
  return request({
    url: prefix + auth + '/user/reload-invite-code',
    method: 'post',
    data
  })
}

/***
 * 获取当前用户的私信列表
 * @param data
 * @returns {AxiosPromise}
 */
export const privateLetterList = data => {
  return request({
    url: prefix + auth + '/private_letter/list',
    method: 'post',
    data
  })
}

/***
 * 读取私信
 * @param data
 * @returns {AxiosPromise}
 */
export const privateLetterRead = data => {
  return request({
    url: prefix + auth + '/private_letter/read',
    method: 'post',
    data
  })
}

/***
 * 注册-邮箱获取验证码
 * @param data
 * @returns {AxiosPromise}
 */
export const userRegisterEmailCode = data => {
  return request({
    url: prefix + '/user/register/email/code',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user/user.js